module.exports = __webpack_public_path__ + "fonts/lato-v17-latin-regular.b8ee546a.woff";